import { render } from "./regular.vue?vue&type=template&id=c991f544&scoped=true&ts=true"
import script from "./regular.vue?vue&type=script&lang=ts"
export * from "./regular.vue?vue&type=script&lang=ts"

import "./regular.vue?vue&type=style&index=0&id=c991f544&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c991f544"]])

export default __exports__